
    <h4 mat-dialog-title>Attachments</h4>
    <div mat-dialog-content>
      <div class="d-flex flex-column">
        <span *ngFor="let link of links">
          <a target="_blank" href="{{link.link}}"
             mat-button
             color="primary"
             class="w-100">
            <span class="text-truncate" title="{{link.filename}}">{{link.filename}}</span>
          </a>
        </span>
      </div>
    </div>
    <div mat-dialog-actions class="mt-3 justify-content-center">
      <button mat-raised-button color="" class="" [mat-dialog-close]="false">Close</button>
    </div>
  